import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import type {
  RecommendedPlayers_card,
  RecommendedPlayers_so5Fixture,
} from './__generated__/index.graphql';

type Props = {
  recommendedCards: RecommendedPlayers_card[];
  so5Fixture?: RecommendedPlayers_so5Fixture;
  onSubmit: () => void;
};
export const RecommendedPlayers = ({
  recommendedCards,
  so5Fixture,
  onSubmit,
}: Props) => {
  return (
    <Vertical>
      <div>Promo anim + each card presentation GW</div>
      <div>{so5Fixture?.gameWeek}</div>
      <div>
        {recommendedCards.map(({ slug }) => (
          <div key={slug}>{slug}</div>
        ))}
      </div>
      <Button size="medium" color="primary" onClick={onSubmit}>
        Continue
      </Button>
    </Vertical>
  );
};

RecommendedPlayers.fragments = {
  so5Fixture: gql`
    fragment RecommendedPlayers_so5Fixture on So5Fixture {
      slug
      id
      gameWeek
    }
  ` as TypedDocumentNode<RecommendedPlayers_so5Fixture>,
  card: gql`
    fragment RecommendedPlayers_card on Card {
      slug
    }
  ` as TypedDocumentNode<RecommendedPlayers_card>,
};
